import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { IssueToolbar } from "@/features/issues/components/issue-toolbar"
import { IssuesTable } from "@/features/issues/components/issues-table"
import { RaiseIssueDialog } from "@/features/issues/components/raise-issue-dialog"
import { issueFilters, issueSearchSchema } from "@/features/issues/issue-search"
import { issueQueries } from "@/queries/issues"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/issues/"
)({
  validateSearch: issueSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) =>
    context.queryClient.ensureQueryData(
      issueQueries.list(issueFilters(deps, { firm_id: params.firmId }))
    ),
  component: FirmIssuesPage,
})

function FirmIssuesPage() {
  const { firmId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader
        title="Issues"
        actions={<RaiseIssueDialog subject={{ type: "firm", id: firmId }} />}
      />
      <section className="flex flex-col gap-4">
        <IssueToolbar
          search={search}
          onSearchChange={(patch) => {
            void navigate({
              replace: true,
              search: (current) => ({ ...current, ...patch }),
            })
          }}
        />
        <IssuesTable
          filters={issueFilters(search, { firm_id: firmId })}
          onPageChange={(page) => {
            void navigate({ search: (current) => ({ ...current, page }) })
          }}
        />
      </section>
    </>
  )
}
